<div mat-dialog-title>
  <div class="row justify-content-end">
    <div class="col-10" *ngIf="titulo" [innerHTML]="titulo">
    </div>
    <div class="col-2 text-right ">
      <i mat-dialog-close role="button" class="fa fa-times" aria-hidden="true"></i>
    </div>

  </div>

</div>
<div mat-dialog-content [innerHTML]="mensagem" *ngIf="mensagem" class="text-center" style="min-height: 120px;color: #426da9;"></div>
<div mat-dialog-actions *ngIf="action" class="justify-content-end">
  <button mat-flat-button mat-dialog-close color="primary">Fechar</button>

</div>
